import { clsx } from '@alexis/helpers/clsx';

import styles from '@components/home/Propositions/Propositions.module.scss';

type PropositionItemProp = {
  title: string;
  imageUrl: string;
};

const PropositionItem: React.FC<PropositionItemProp> = ({ title, imageUrl }) => {
  return (
    <div className={clsx(styles.proposition, styles.itemsCenter)}>
      <div className={styles.iconContainer}>
        <img src={imageUrl} alt={title} height={96} width={96} />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.title}>{title}</div>
      </div>
    </div>
  );
};

export default PropositionItem;
